import ListWorkers from "../../../../components/@users/workers/ListWorkers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WorkersPage() {

    return (
        <ListWorkers 
            routeType={routeTypes.admin}
        />
    )
}       